<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="1250px"
      @click:outside="cerrarDialogo(false)"
      @keydown.esc="cerrarDialogo(false)"
      scrollable
    >
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <!-- Toolbar Header -->
        <v-toolbar height="60" color="secondary" dark flat class="px-3">
          <v-icon left>mdi-truck</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Item.id == "" ? "Registro de Vehículo" : "Editar Vehículo" }}
          </span>
          <v-chip
            v-if="Item.id != ''"
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-pound</v-icon>
            ID: {{ Item.id }}
          </v-chip>
          <v-chip
            v-if="Item.id != '' && Item.placa"
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-2 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-car-settings</v-icon>
            Placa: {{ Item.placa }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarDialogo(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Alerta de permisos -->
        <v-slide-y-transition>
          <v-alert
            v-if="snackbarPermisos"
            type="warning"
            dense
            text
            dismissible
            class="mx-4 mt-3 mb-0 rounded-md"
            @input="snackbarPermisos = false"
          >
            Para realizar esta acción debe solicitar autorización a su
            supervisor.
          </v-alert>
        </v-slide-y-transition>

        <v-card-text
          class="pa-5"
          style="max-height: calc(90vh - 130px); overflow-y: auto"
        >
          <v-form ref="form" v-model="valid">
            <!-- SECCIÓN 1: DATOS DEL CLIENTE -->
            <div class="mb-4">
              <div class="d-flex align-center mb-3">
                <v-icon small color="primary" class="mr-2">mdi-domain</v-icon>
                <span class="text-subtitle-1 font-weight-bold text--primary"
                  >Datos del Cliente</span
                >
              </div>
              <v-row dense>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    label="Razón Social"
                    v-model="RazonSocial"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-domain"
                    hide-details="auto"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    label="RUC"
                    v-model="Ruc"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-card-account-details"
                    hide-details="auto"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-autocomplete
                    :items="ItemsPlanta"
                    v-model="Item.id_planta"
                    label="Seleccione Planta"
                    outlined
                    dense
                    prepend-inner-icon="mdi-factory"
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </div>

            <v-divider class="my-4"></v-divider>

            <!-- SECCIÓN 2: DATOS DEL VEHÍCULO -->
            <div class="mb-4">
              <div class="d-flex align-center mb-3">
                <v-icon small color="primary" class="mr-2"
                  >mdi-truck-outline</v-icon
                >
                <span class="text-subtitle-1 font-weight-bold text--primary"
                  >Datos del Vehículo</span
                >
              </div>

              <v-row dense>
                <!-- Tipo de Vehículo con botón agregar y edición -->
                <v-col cols="12" sm="6" md="3">
                  <div class="d-flex align-center">
                    <v-autocomplete
                      @change="verConfiguracion"
                      :items="ItemsTipo"
                      v-model="Item.id_tipo"
                      label="Tipo de Vehículo *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-truck-cargo-container"
                      :rules="[(v) => !!v || 'Tipo de vehículo es requerido']"
                      hide-details="auto"
                      class="mr-2"
                    >
                      <template slot="item" slot-scope="{ item }">
                        <div
                          class="d-flex justify-space-between align-center w-100 py-1"
                        >
                          <span>{{ item.text }}</span>
                          <v-icon
                            small
                            color="primary"
                            @click.stop="openModalTipoVehiculo(item)"
                            >mdi-pencil</v-icon
                          >
                        </div>
                      </template>
                    </v-autocomplete>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          height="40"
                          width="40"
                          class="elevation-1 flex-shrink-0"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="openModalTipoVehiculo()"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Nuevo Tipo Vehículo</span>
                    </v-tooltip>
                  </div>
                </v-col>

                <!-- Placa -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    label="N° de Placa *"
                    v-model="Item.placa"
                    outlined
                    dense
                    prepend-inner-icon="mdi-car-settings"
                    :rules="[(v) => !!v || 'Placa de vehículo es requerido']"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <!-- Código de Vehículo -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    label="Código de Vehículo"
                    v-model="Item.codigo"
                    outlined
                    dense
                    prepend-inner-icon="mdi-barcode"
                    placeholder="Opcional"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <!-- Año de Fabricación -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    label="Año de Fabricación"
                    v-model="Item.fecha_fabricacion"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar-range"
                    hint="Ejemplo: 2016"
                    persistent-hint
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <!-- Aplicación -->
                <v-col cols="12" sm="6" md="3" class="mt-2">
                  <v-autocomplete
                    :items="ItemsAplicacion"
                    v-model="Item.ruta"
                    label="Seleccione Aplicación *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-routes"
                    :rules="[(v) => !!v || 'Aplicación es requerida']"
                    hide-details="auto"
                  ></v-autocomplete>

                  <!-- Detalle informativo de límites de reencauche -->
                  <v-slide-y-transition>
                    <div
                      v-if="aplicacionSeleccionada && (aplicacionSeleccionada.rem_reencauche != null || aplicacionSeleccionada.rem_proximo != null)"
                      class="app-remanente-card mt-2 pa-2 rounded elevation-1"
                    >
                      <div class="d-flex align-center justify-space-between mb-1">
                        <span class="caption text-caption font-weight-medium grey--text text--darken-3 d-flex align-center">
                          <v-icon x-small color="error" class="mr-1">mdi-tire</v-icon>
                          Límite Reencauche:
                        </span>
                        <v-chip
                          x-small
                          color="red lighten-5"
                          text-color="red darken-3"
                          class="font-weight-bold px-2"
                        >
                          {{ aplicacionSeleccionada.rem_reencauche != null ? aplicacionSeleccionada.rem_reencauche + ' mm' : '-' }}
                        </v-chip>
                      </div>
                      <div class="d-flex align-center justify-space-between">
                        <span class="caption text-caption font-weight-medium grey--text text--darken-3 d-flex align-center">
                          <v-icon x-small color="amber darken-3" class="mr-1">mdi-timer-sand</v-icon>
                          Próx. a Reencauchar:
                        </span>
                        <v-chip
                          x-small
                          color="amber lighten-5"
                          text-color="amber darken-4"
                          class="font-weight-bold px-2"
                        >
                          {{ aplicacionSeleccionada.rem_proximo != null ? aplicacionSeleccionada.rem_proximo + ' mm' : '-' }}
                        </v-chip>
                      </div>
                    </div>
                  </v-slide-y-transition>
                </v-col>

                <!-- Marca -->
                <v-col cols="12" sm="6" md="3" class="mt-2">
                  <div class="d-flex align-center">
                    <v-autocomplete
                      :items="ItemsMarca"
                      v-model="Item.id_marca"
                      label="Seleccionar Marca *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-watermark"
                      :rules="[(v) => !!v || 'Marca es requerida']"
                      hide-details="auto"
                      @change="
                        Item.id_modelo = null;
                        cargarModelos(Item.id_marca);
                      "
                      class="mr-2"
                    ></v-autocomplete>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          height="40"
                          width="40"
                          class="elevation-1 flex-shrink-0"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="openModalMarca()"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Nueva Marca</span>
                    </v-tooltip>
                  </div>
                </v-col>

                <!-- Modelo -->
                <v-col cols="12" sm="6" md="3" class="mt-2">
                  <div class="d-flex align-center">
                    <v-autocomplete
                      :items="modeloVehiculoPorMarcaList"
                      v-model="Item.id_modelo"
                      label="Seleccionar Modelo *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-truck-check"
                      :rules="[(v) => !!v || 'Modelo es requerido']"
                      hide-details="auto"
                      class="mr-2"
                    ></v-autocomplete>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          height="40"
                          width="40"
                          class="elevation-1 flex-shrink-0"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="openModalModelo()"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Nuevo Modelo</span>
                    </v-tooltip>
                  </div>
                </v-col>

                <!-- Tipo de Costo -->
                <v-col cols="12" sm="6" md="3" class="mt-2">
                  <v-autocomplete
                    :items="arraycosto"
                    v-model="Item.tipo_costo"
                    label="Seleccione Tipo Costo *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-cash-multiple"
                    :rules="[(v) => !!v || 'Tipo de costo es requerido']"
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>

                <!-- Configuración -->
                <v-col cols="12" sm="6" md="3" class="mt-2">
                  <v-autocomplete
                    :items="ItemsConfiguracion"
                    v-model="Item.id_configuracion"
                    label="Seleccione Configuración *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-axis-arrow"
                    @change="cargarneumaticos"
                    :rules="[(v) => !!v || 'Configuración es requerida']"
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>

                <!-- Estado del Vehículo (Solo en edición) -->
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="mt-2"
                  v-if="Item.id != ''"
                >
                  <v-autocomplete
                    :items="ItemsEstadoVehiculo"
                    v-model="Item.estado"
                    label="Seleccione Estado del Vehículo *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-check-circle-outline"
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>

                <!-- Km/Hr Inicial y Desbloqueo (Solo en edición) -->
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="mt-2"
                  v-if="Item.id != ''"
                >
                  <div class="d-flex align-center">
                    <v-text-field
                      label="Km/Hr Instalación"
                      v-model="Item.edit_kilometraje"
                      :disabled="habilitarInstalacion"
                      outlined
                      dense
                      prepend-inner-icon="mdi-counter"
                      hide-details="auto"
                      @input="validateKilometraje"
                      :rules="[rules.onlyNumbers, rules.minimumZero]"
                      class="mr-2"
                    ></v-text-field>
                  </div>
                  <small
                    v-if="Item.editkm == 0"
                    class="red--text text-caption mt-1 d-block"
                  >
                    El Km/Hr no se puede modificar.
                  </small>
                  <small
                    v-else-if="!habilitarInstalacion"
                    class="orange--text text--darken-2 text-caption mt-1 d-block"
                  >
                    El Km/Hr de instalación se va a modificar
                  </small>
                </v-col>

                <!-- Fecha de Instalación -->
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="mt-2"
                  v-if="Item.id != ''"
                >
                  <div class="d-flex align-center">
                    <v-text-field
                      type="date"
                      label="Fecha de Instalación"
                      v-model="Item.edit_fecha_instalacion"
                      :disabled="habilitarInstalacion"
                      outlined
                      dense
                      prepend-inner-icon="mdi-calendar"
                      hide-details="auto"
                      class="mr-2"
                    ></v-text-field>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="
                            Item.editkm == 0
                              ? 'grey'
                              : habilitarInstalacion
                              ? 'success'
                              : 'warning'
                          "
                          height="40"
                          width="40"
                          class="elevation-1 flex-shrink-0"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            Item.editkm == 0
                              ? null
                              : habilitarInstalacion
                              ? validareditkmandfecha()
                              : (habilitarInstalacion = true)
                          "
                        >
                          <v-icon small>
                            {{
                              !habilitarInstalacion && Item.editkm != 0
                                ? "mdi-lock-open-variant-outline"
                                : "mdi-lock-outline"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{
                          Item.editkm == 0
                            ? "No se puede modificar porque no existen neumáticos instalados"
                            : habilitarInstalacion
                            ? "Solicitar desbloqueo de Km/Hr y fecha de instalación"
                            : "Bloquear edición"
                        }}
                      </span>
                    </v-tooltip>
                  </div>
                  <small
                    v-if="Item.editkm == 0"
                    class="red--text text-caption mt-1 d-block"
                  >
                    La fecha no se puede modificar.
                  </small>
                  <small
                    v-else-if="!habilitarInstalacion"
                    class="orange--text text--darken-2 text-caption mt-1 d-block"
                  >
                    La fecha de instalación se va a modificar
                  </small>
                </v-col>
              </v-row>
            </div>

            <!-- SECCIÓN 3: ESQUEMA DE EJES Y NEUMÁTICOS -->
            <v-slide-y-transition>
              <div v-if="MostrarConfiguracion == true" class="mt-4">
                <v-divider class="my-4"></v-divider>
                <div class="d-flex align-center justify-space-between mb-3">
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-axis-arrow</v-icon
                    >
                    <span
                      class="text-subtitle-1 font-weight-bold text--primary"
                    >
                      Esquema de Configuración de Ejes
                    </span>
                  </div>
                  <span class="text-caption grey--text text--darken-1">
                    Haga clic en una posición para ver detalles del neumático
                  </span>
                </div>

                <v-card
                  outlined
                  class="pa-4 rounded-lg schematic-card d-flex justify-center overflow-x-auto"
                >
                  <div class="table-responsive">
                    <table class="table">
                      <tbody>
                        <tr>
                          <td class="pa-2"></td>
                          <td class="pa-2" id="p6">
                            <v-btn
                              v-if="ItemLlantas[6].posicion != null"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                              @click="abrirmodaleditarkm(6)"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[6].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p10">
                            <v-btn
                              v-if="ItemLlantas[10].posicion != null"
                              @click="abrirmodaleditarkm(10)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[10].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p14">
                            <v-btn
                              v-if="ItemLlantas[14].posicion != null"
                              @click="abrirmodaleditarkm(14)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[14].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p18">
                            <v-btn
                              v-if="ItemLlantas[18].posicion != null"
                              @click="abrirmodaleditarkm(18)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[18].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p22">
                            <v-btn
                              v-if="ItemLlantas[22].posicion != null"
                              @click="abrirmodaleditarkm(22)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[22].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                        </tr>
                        <tr>
                          <td class="pa-2" id="p2">
                            <v-btn
                              v-if="ItemLlantas[2].posicion != null"
                              @click="abrirmodaleditarkm(2)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[2].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p4">
                            <v-btn
                              v-if="ItemLlantas[4].posicion != null"
                              @click="abrirmodaleditarkm(4)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[4].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p8">
                            <v-btn
                              v-if="ItemLlantas[8].posicion != null"
                              @click="abrirmodaleditarkm(8)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[8].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p12">
                            <v-btn
                              v-if="ItemLlantas[12].posicion != null"
                              @click="abrirmodaleditarkm(12)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[12].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p16">
                            <v-btn
                              v-if="ItemLlantas[16].posicion != null"
                              @click="abrirmodaleditarkm(16)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[16].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p20">
                            <v-btn
                              v-if="ItemLlantas[20].posicion != null"
                              @click="abrirmodaleditarkm(20)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[20].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                        </tr>
                        <tr>
                          <td class="pa-2"></td>
                        </tr>
                        <tr>
                          <td class="pa-2"></td>
                        </tr>
                        <tr>
                          <td class="pa-2" id="p1">
                            <v-btn
                              v-if="ItemLlantas[1].posicion != null"
                              @click="abrirmodaleditarkm(1)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[1].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p3">
                            <v-btn
                              v-if="ItemLlantas[3].posicion != null"
                              @click="abrirmodaleditarkm(3)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[3].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p7">
                            <v-btn
                              v-if="ItemLlantas[7].posicion != null"
                              @click="abrirmodaleditarkm(7)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[7].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p11">
                            <v-btn
                              v-if="ItemLlantas[11].posicion != null"
                              @click="abrirmodaleditarkm(11)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[11].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p15">
                            <v-btn
                              v-if="ItemLlantas[15].posicion != null"
                              @click="abrirmodaleditarkm(15)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[15].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p19">
                            <v-btn
                              v-if="ItemLlantas[19].posicion != null"
                              @click="abrirmodaleditarkm(19)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[19].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                        </tr>
                        <tr>
                          <td class="pa-2"></td>
                          <td class="pa-2" id="p5">
                            <v-btn
                              v-if="ItemLlantas[5].posicion != null"
                              @click="abrirmodaleditarkm(5)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[5].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p9">
                            <v-btn
                              v-if="ItemLlantas[9].posicion != null"
                              @click="abrirmodaleditarkm(9)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[9].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p13">
                            <v-btn
                              v-if="ItemLlantas[13].posicion != null"
                              @click="abrirmodaleditarkm(13)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[13].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p17">
                            <v-btn
                              v-if="ItemLlantas[17].posicion != null"
                              @click="abrirmodaleditarkm(17)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[17].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                          <td class="pa-2" id="p21">
                            <v-btn
                              v-if="ItemLlantas[21].posicion != null"
                              @click="abrirmodaleditarkm(21)"
                              small
                              height="30"
                              class="pa-0 tire-btn"
                            >
                              <v-img
                                dark
                                position="center"
                                src="/images/llanta2.png"
                                height="30"
                                width="75"
                              >
                                <v-col
                                  class="text-center pt-2 font-weight-bold"
                                  style="font-size: 11px"
                                >
                                  {{ "P" + ItemLlantas[21].posicion }}
                                </v-col>
                              </v-img>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-card>
              </div>
            </v-slide-y-transition>
          </v-form>

          <MensajeTransicion
            :color="color"
            :text="mensaje"
            v-if="verAlerta"
            :top="true"
            :bottom="false"
          />
        </v-card-text>

        <v-divider></v-divider>

        <!-- Footer Actions -->
        <v-card-actions class="pa-4 bg-actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-2"
            class="mr-2 text-capitalize px-4"
            @click="cerrarDialogo(false)"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="info"
            :loading="loading"
            class="px-6 text-capitalize font-weight-bold elevation-1"
            @click="agregar()"
          >
            <v-icon left small>mdi-content-save</v-icon>
            {{ Item.id == "" ? "Guardar" : "Actualizar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL EDIT KILOMETRAJE / DETALLE NEUMATICO-->
    <v-dialog
      v-if="dialogeditkm"
      v-model="dialogeditkm"
      max-width="560px"
      @click:outside="cerrarDialogKm"
    >
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-3">
          <v-icon left small>mdi-tire</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Detalle del Neumático</span
          >
          <v-chip
            v-if="arryNeumatico && arryNeumatico.num_serie"
            color="white"
            text-color="primary"
            class="font-weight-bold ml-2 px-3 elevation-1"
            style="font-size: 0.85rem; height: 28px"
          >
            <v-icon left size="16" color="primary">mdi-barcode-scan</v-icon>
            Serie: {{ arryNeumatico.num_serie }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarDialogKm()">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-text-field
                type="text"
                label="Marca"
                v-model="arryNeumatico.marca"
                outlined
                dense
                hide-details="auto"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                type="text"
                label="Modelo"
                v-model="arryNeumatico.modelo"
                outlined
                dense
                hide-details="auto"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                type="text"
                label="Medida"
                v-model="arryNeumatico.medida"
                outlined
                dense
                hide-details="auto"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="mt-2">
              <v-text-field
                type="text"
                label="Condición"
                v-model="arryNeumatico.condicion"
                outlined
                dense
                hide-details="auto"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="mt-2">
              <v-text-field
                type="text"
                label="Diseño (R)"
                v-model="arryNeumatico.disenio"
                outlined
                dense
                hide-details="auto"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="mt-2">
              <v-text-field
                type="text"
                label="Presión (PSI)"
                v-model="arryNeumatico.presion"
                outlined
                dense
                hide-details="auto"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="mt-2">
              <v-text-field
                type="date"
                label="Inspección/Instalación"
                v-model="arryNeumatico.fechita"
                outlined
                dense
                hide-details="auto"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="mt-2">
              <v-text-field
                type="text"
                label="NSD"
                v-model="arryNeumatico.remanente_actual"
                outlined
                dense
                hide-details="auto"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="mt-2">
              <v-text-field
                type="text"
                label="Km/Hr"
                v-model="arryNeumatico.kilometraje"
                outlined
                dense
                readonly
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="cerrarDialogKm()">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL ADD / EDIT TIPO VEHICULO-->
    <v-dialog
      v-if="modal_form_tipovehiculo"
      v-model="dialogTipoVehiculo"
      max-width="450px"
      @click:outside="cerrarDialogTipoVehiculo"
    >
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>{{
            tipovehiculo.id ? "mdi-pencil" : "mdi-plus-circle"
          }}</v-icon>
          <span class="text-subtitle-1 font-weight-medium">
            {{
              tipovehiculo.id
                ? "Editar Tipo de Vehículo"
                : "Nuevo Tipo de Vehículo"
            }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarDialogTipoVehiculo">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="formtipovehiculo" v-model="valid_tipo_vehiculo">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    label="Nombre del tipo de vehículo *"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-truck-outline"
                    v-model="tipovehiculo.descripcion"
                    :rules="[
                      (v) => !!v || 'Descripción es requerido',
                      (v) =>
                        /^[a-zA-Z0-9\s]+$/.test(v) ||
                        'No se permiten caracteres especiales',
                    ]"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  v-if="mostrarLabelDuplicado && !tipovehiculo.id"
                  class="mt-2"
                >
                  <v-alert dense type="error" text class="text-caption mb-0">
                    Tipo de Vehículo duplicado
                  </v-alert>
                </v-col>
                <v-col cols="12" class="mt-3">
                  <span
                    class="text-caption font-weight-bold grey--text text--darken-2"
                    >IMAGEN REFERENCIAL:</span
                  >
                  <div
                    class="my-2 d-flex justify-center align-center pa-2 border rounded"
                    v-if="tipovehiculo.id && verificartipovehiculo()"
                  >
                    <img
                      width="120px"
                      height="auto"
                      :src="tipovehiculo.file_view"
                      class="rounded"
                    />
                  </div>
                  <v-file-input
                    label="Seleccionar archivo de imagen"
                    id="file"
                    outlined
                    dense
                    prepend-icon=""
                    prepend-inner-icon="mdi-camera"
                    hide-details="auto"
                    class="mt-2"
                    @input="archivosubido1"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text mt-2 d-block">
            * Recuerde vincular el vehículo con su configuración
          </small>
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="cerrarDialogTipoVehiculo">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid_tipo_vehiculo"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addTipoVehiculo(tipovehiculo)"
          >
            {{ tipovehiculo.id ? "Guardar Cambios" : "Agregar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL ADD MARCA-->
    <v-dialog
      v-if="modal_form_marca"
      v-model="dialogMarca"
      max-width="420px"
      @click:outside="cerrarDialogMarca"
    >
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>mdi-plus-circle</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Nueva Marca de Vehículo</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarDialogMarca">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="form-marca" v-model="valid">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    label="Nombre de la marca *"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-watermark"
                    v-model="marca.descripcion"
                    :rules="descripcionRules"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="mostrarLabelDuplicado" class="mt-2">
                  <v-alert dense type="error" text class="text-caption mb-0">
                    Marca duplicada
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text mt-2 d-block">
            * Indicador de campo requerido
          </small>
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="cerrarDialogMarca">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addMarca(marca)"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL ADD MODELO-->
    <v-dialog
      v-if="modal_form_modelo"
      v-model="dialogModelo"
      max-width="450px"
      @click:outside="cerrarDialogModelo"
    >
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>mdi-plus-circle</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Nuevo Modelo de Vehículo</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarDialogModelo">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="form-modelo" v-model="valid">
              <v-row dense>
                <v-col cols="12">
                  <v-autocomplete
                    :items="ItemsMarca"
                    v-model="modelo.id_marca"
                    label="Marca de vehículo *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-watermark"
                    :rules="[(v) => !!v || 'Marca es requerido']"
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-3">
                  <v-text-field
                    label="Nombre del modelo *"
                    placeholder="Ej. FH540"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-truck-check"
                    v-model="modelo.descripcion"
                    :rules="descripcionRules"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="mostrarLabelDuplicado" class="mt-2">
                  <v-alert dense type="error" text class="text-caption mb-0">
                    Modelo duplicado
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text mt-2 d-block">
            * Indicador de campo requerido
          </small>
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="cerrarDialogModelo">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addModelo(modelo)"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import global from "../../global";
import Alerta from "../alertas.vue";
import MensajeTransicion from "../Alerta.vue";
import FileTipoVehiculo from "../FileTipoVehiculo.vue";
import { notif } from "@/plugins/notyf";
import { axios2 as axios } from "@/interceptor/useApi";

export default {
  props: ["dialog", "Item"],
  emits: ["cargarDatosAdicionales", "actualizarListado"],
  components: {
    Alerta,
    MensajeTransicion,
    FileTipoVehiculo,
  },
  data() {
    return {
      mostrarlabeltipo_vehiculo: false,
      file: [],
      valid: false,
      valid_tipo_vehiculo: false,
      loading: false,
      marca: {},
      tipovehiculo: {},
      modelo: {},
      arraycosto: [
        {
          value: 1,
          text: "Por Kilometros",
        },
        {
          value: 2,
          text: "Por Horas",
        },
      ],
      ItemLlantas: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false,
        13: false,
        14: false,
        15: false,
        16: false,
        17: false,
        18: false,
        19: false,
        20: false,
        21: false,
        22: false,
      },
      ItemLlantasNombre: {
        nombre_p1: "p1",
        nombre_p2: "p2",
        nombre_p3: "p3",
        nombre_p4: "p4",
        nombre_p5: "p5",
        nombre_p6: "p6",
        nombre_p7: "p7",
        nombre_p8: "p8",
        nombre_p9: "p9",
        nombre_p10: "p10",
        nombre_p11: "p11",
        nombre_p12: "p12",
        nombre_p13: "p13",
        nombre_p14: "p14",
        nombre_p15: "p15",
        nombre_p16: "p16",
        nombre_p17: "p17",
        nombre_p18: "p18",
        nombre_p19: "p19",
        nombre_p20: "p20",
        nombre_p21: "p21",
        nombre_p22: "p22",
      },
      ItemsEstadoVehiculo: [
        {
          value: 0,
          text: "No Activo",
        },
        {
          value: 1,
          text: "Activo",
        },
      ],
      color: "success",
      verAlerta: false,
      mensaje: "",
      dialogTipoVehiculo: false,
      dialogMarca: false,
      dialogModelo: false,
      MostrarConfiguracion: true,
      mostrarLabelDuplicado: false,
      modal_form_modelo: false,
      modal_form_marca: false,
      modal_form_tipovehiculo: false,
      modal_form_vehiculo: true,
      arryNeumatico: [],
      descripcionRules: [(v) => !!v || "Descripción es requerido"],
      dialogeditkm: false,

      rules: {
        onlyNumbers: (value) =>
          /^[0-9]*\.?[0-9]+$/.test(value) || "Solo números o números decimales",
        minimumZero: (value) => value >= 0 || "Debe ser mayor o igual a 0",
      },
      habilitarInstalacion: true,
      snackbarPermisos: false,

      modeloVehiculoPorMarcaList: [],
    };
  },
  computed: {
    ...mapGetters("vehiculo", [
      "RazonSocial",
      "Ruc",
      "ItemsPlanta",
      "ItemsTipo",
      "ItemsAplicacion",
      "ItemsMarca",
      "ItemsModelo",
      "ItemsConfiguracion",
      "Item_vehiculo",
      "ItemsNeumaticos",
    ]),
    ...mapState("navigation", ["Permisos"]),
    aplicacionSeleccionada() {
      if (
        !this.Item ||
        this.Item.ruta === null ||
        this.Item.ruta === undefined ||
        this.Item.ruta === ""
      ) {
        return null;
      }
      return (
        this.ItemsAplicacion.find(
          (app) =>
            app.value == this.Item.ruta ||
            app.id == this.Item.ruta ||
            app.id_aplicacion == this.Item.ruta ||
            (app.text &&
              String(app.text).toUpperCase() ===
                String(this.Item.ruta).toUpperCase()) ||
            (app.aplicacion &&
              String(app.aplicacion).toUpperCase() ===
                String(this.Item.ruta).toUpperCase())
        ) || null
      );
    },
  },
  methods: {
    ...mapActions("vehiculo", [
      "cargarVehiculosFind",
      "agregarVehiculo",
      "cargarConfiguracion",
      "cargarPosicionNeumatico",
      "agregarItemArray",
    ]),
    archivosubido1: function () {
      let file = document.getElementById("file").files[0];
      console.log(file, "fileeee");
      this.tipovehiculo.file = file;
      this.file = file;
    },
    validareditkmandfecha() {
      const role = localStorage.getItem("role");
      if (role != 1 && role != 2) {
        this.snackbarPermisos = true;
        setTimeout(() => {
          this.snackbarPermisos = false;
        }, 4000);
        return;
      }
      if (this.Item.editkm == 0) {
        this.habilitarInstalacion = true;
      } else {
        this.habilitarInstalacion = false;
      }
    },
    validateKilometraje(value) {
      // Validar si el valor es numérico
      if (!/^[0-9]*\.?[0-9]+$/.test(value)) {
        this.kilometrajeError1 = "Solo se permiten números";
        return false;
      }
      // Validar si es mayor o igual a 0
      if (value < 0) {
        this.kilometrajeError1 = "Debe ser mayor o igual a 0";
        return false;
      }
      // Validar que no sea nulo
      if (value == "" && value != 0) {
        this.kilometrajeError1 = "No debe ser nulo";
        return false;
      }
      this.kilometrajeError = ""; // No hay errores
      return true;
    },

    EditarrrKM: async function () {
      if (this.validateKilometraje(this.arryNeumatico.kilometraje)) {
        let url = "neumatico/edit/kilometraje";
        const data = {
          id_neumatico: this.arryNeumatico.id,
          id_vehiculo: this.Item.id,
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          kilometraje: this.arryNeumatico.kilometraje,
        };
        await axios
          .post(url, data)
          .then(async (response) => {
            notif.success(
              "El Kilometraje del neumatico se actualizo correctamente",
            );
            this.cerrarDialogKm();
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
          });
      } else {
        notif.error("El kilometraje ingresado debe ser un numero mayor a 0");
      }
    },

    verificartipovehiculo() {
      if (
        this.tipovehiculo.file !=
        global.ruta_image + "images/tipovehiculo/null"
      ) {
        return true;
      } else {
        return false;
      }
    },

    abrirmodaleditarkm: async function (param) {
      if (this.Item.id != "") {
        this.dialogeditkm = false;
        let url = "inspecciones/datneumaticos";
        const data = {
          posicion: this.ItemLlantas[param].posicion,
          ubicacion: this.ItemLlantas[param].ubicacion,
          id_cliente: localStorage.getItem("idcliente"),
          id_vehiculo: this.Item.id,
          id_configuracion: this.Item.id_configuracion,
        };
        await axios
          .post(url, data)
          .then(async (response) => {
            console.log(response, "response");
            this.arryNeumatico = response.data.success.posicion;
            if (this.arryNeumatico.length == 0) {
              console.log("alerta");
              notif.error(response.data.message);
            } else {
              this.arryNeumatico = this.arryNeumatico[0];
              this.dialogeditkm = true;
            }
          })
          .catch((error) => {
            notif.error(
              "Este vehiculo ya cuenta con una inspeccion y por ese motivo no se puede editar su kilometraje",
            );
            this.errorMessage = error.response.data;
            console.error("error!", error);
          });
      }
    },

    inicializarMarca: function () {
      this.marca = {
        descripcion: null,
      };
    },

    inicializarModelo: function () {
      this.modelo = {
        id_marca: null,
        descripcion: null,
      };
    },

    openModalMarca() {
      this.mostrarLabelDuplicado = false;
      this.inicializarMarca();
      this.$nextTick().then(() => {
        this.modal_form_marca = true;
      });
      this.dialogMarca = true;
    },
    openModalTipoVehiculo(item) {
      console.log(item, "item");
      this.mostrarLabelDuplicado = false;
      this.$nextTick().then(() => {
        if (item) {
          this.tipovehiculo.descripcion = item.text;
          this.tipovehiculo.file = item.img;
          this.tipovehiculo.file_view = item.img;
          this.tipovehiculo.id = item.value;
          this.valid_tipo_vehiculo = true;
        } else {
          this.tipovehiculo = [];
        }
        this.$nextTick().then(() => {
          this.modal_form_tipovehiculo = true;
          this.dialogTipoVehiculo = true;
        });
      });
    },

    openModalModelo() {
      this.mostrarLabelDuplicado = false;
      this.$nextTick().then(() => {
        this.modal_form_modelo = true;
      });
      this.inicializarModelo();
      if (this.Item.id_marca != null) {
        this.modelo.id_marca = this.Item.id_marca;
      }
      this.dialogModelo = true;
    },

    addMarca: async function (item) {
      if (
        !global.verificarDuplicados(
          this.ItemsMarca,
          item.descripcion.toUpperCase(),
        )
      ) {
        //Guardar en la base de datos
        item.descripcion = item.descripcion.toUpperCase();

        let dato = await this.agregarItemArray({
          url: "vehiculomarca/store",
          item: item,
        });

        this.ItemsMarca.push({
          value: dato.id,
          text: dato.marca,
        });
        this.dialogMarca = false;
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addTipoVehiculo: async function (item) {
      let file = document.getElementById("file").files[0];
      this.tipovehiculo.file = file;
      this.file = file;
      if (
        (!global.verificarDuplicados(
          this.ItemsTipo,
          item.descripcion.toUpperCase(),
        ) &&
          !this.tipovehiculo.id) ||
        this.tipovehiculo.id
      ) {
        //Guardar en la base de datos
        item.descripcion = item.descripcion.toUpperCase();
        if (item.id) {
          const formData = new FormData();
          formData.append("id_cliente", localStorage.getItem("idcliente"));
          formData.append("nombre", item.descripcion);
          if (this.file) {
            formData.append("file", this.file);
          }
          let url = "vehiculo/tipo/update/" + item.id;
          await axios
            .post(url, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
              this.$refs.formtipovehiculo.reset();
              document.getElementById("file").value = null;
              this.dialogTipoVehiculo = false;
              this.mostrarlabeltipo_vehiculo = true;
              this.tipovehiculo = [];
              this.file = null;
              this.$emit("cargarDatosAdicionales");
              this.$alertify.success(
                "Se edito correctamente el tipo de vehiculo",
              );
            })
            .catch((error) => {
              this.errorMessage = error.response.data;
              console.error("error!", error);
            });
        } else {
          const formData = new FormData();
          formData.append("id_cliente", localStorage.getItem("idcliente"));
          formData.append("nombre", item.descripcion);
          if (this.file) {
            formData.append("file", this.file);
          }
          let url = "vehiculo/tipo/store";
          await axios
            .post(url, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
              this.$refs.formtipovehiculo.reset();
              document.getElementById("file").value = null;
              this.dialogTipoVehiculo = false;
              this.mostrarlabeltipo_vehiculo = true;
              this.tipovehiculo = [];
              this.file = null;
              this.$emit("cargarDatosAdicionales");
              this.$alertify.success(
                "Se agrego correctamente el tipo de vehiculo",
              );
            })
            .catch((error) => {
              this.errorMessage = error.response.data;
              console.error("error!", error);
            });
        }
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addModelo: async function (item) {
      if (
        !global.verificarDuplicados(
          this.ItemsModelo,
          item.descripcion.toUpperCase(),
        )
      ) {
        item.descripcion = item.descripcion.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "vehiculomodelo/store",
          item: item,
        });
        this.ItemsModelo.push({
          value: dato.id,
          text: dato.modelo,
          marca: dato.id_marca,
        });
        this.dialogModelo = false;
        this.cargarModelos(dato.id_marca);
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    async validar() {
      let existe = false;
      try {
        // Verificar si la placa ya existe en la lista de vehículos
        await this.cargarVehiculosFind({
          page: 1,
          per_page: 10,
          placa: this.Item.placa,
          sortBy: "id",
          sortDirection: "DESC",
        }).then(() => {
          if (this.Item_vehiculo.total > 0) {
            existe = true;
          } else {
            existe = false;
          }
        });
      } catch (error) {
        console.error("Error en validar:", error);
      }
      return existe;
    },

    async agregar() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.Item.id == "") {
          const esValido = await this.validar();
          if (!esValido) {
            await this.agregarVehiculo(this.Item).then((r) => {
              const isSuccess =
                r?.data?.success !== false && r?.data?.status !== false;
              if (isSuccess) {
                notif.success(
                  "Se registro el vehículo de placa: " + this.Item.placa,
                );
                this.loading = false;
                this.MostrarConfiguracion = false;
                this.cerrarDialogo(true);
                this.$emit("actualizarListado");
              } else {
                this.loading = false;
              }
            });
          } else {
            this.loading = false;
            this.color = "#FA694A";
            this.verAlerta = true;
            setTimeout(() => [(this.verAlerta = false)], 4000);
            this.mensaje = "El número de placa ya se encuentra registrada";
          }
        } else {
          this.Item.edit_status = !this.habilitarInstalacion;
          if (this.Item.edit_status == false) {
            this.agregarVehiculo(this.Item).then((r) => {
              const isSuccess =
                r?.data?.success !== false && r?.data?.status !== false;
              if (isSuccess) {
                notif.success(
                  "Se actualizó el vehículo de placa: " + this.Item.placa,
                );
                this.loading = false;
                this.MostrarConfiguracion = false;
                this.cerrarDialogo(true);
                this.$emit("actualizarListado");
              } else {
                this.loading = false;
              }
            });
          } else {
            if (this.validateKilometraje(this.Item.edit_kilometraje)) {
              await this.agregarVehiculo(this.Item).then((r) => {
                const isSuccess =
                  r?.data?.success !== false && r?.data?.status !== false;
                if (isSuccess) {
                  notif.success(
                    "Se actualizó el vehículo de placa: " + this.Item.placa,
                  );
                  this.loading = false;
                  this.MostrarConfiguracion = false;
                  this.cerrarDialogo(true);
                  this.$emit("actualizarListado");
                } else {
                  this.loading = false;
                }
              });
            } else {
              this.loading = false;
              notif.error(
                "El kilometraje ingresado debe ser un numero mayor a 0",
              );
            }
          }
        }
      }
    },

    cargarModelos: function (id_marca) {
      console.log(
        this.modeloVehiculoPorMarcaList,
        id_marca,
        "id_marca",
        this.ItemsModelo,
      );
      this.modeloVehiculoPorMarcaList = [];
      this.ItemsModelo.forEach((element) => {
        if (element.marca == id_marca) {
          this.modeloVehiculoPorMarcaList.push(element);
        }
      });
    },

    cerrarDialogo(valor) {
      this.$emit("dialog", false);
      this.$emit("cerrarModal", valor);
      //this.cargarAplicacion;
    },
    cerrarDialogKm() {
      this.dialogeditkm = false;
      this.arryNeumatico = [];
    },

    cerrarDialogModelo() {
      this.dialogModelo = false;
      this.modal_form_modelo = false;
    },

    cerrarDialogMarca() {
      this.dialogMarca = false;
      this.modal_form_marca = false;
    },

    cerrarDialogTipoVehiculo() {
      this.$refs.formtipovehiculo.reset();
      document.getElementById("file").value = null;
      this.dialogTipoVehiculo = false;
      this.mostrarlabeltipo_vehiculo = true;
      this.tipovehiculo = [];
      this.file = null;
      this.dialogTipoVehiculo = false;
      this.modal_form_tipovehiculo = false;
    },

    verConfiguracion() {
      this.Item.id_configuracion = null;
      this.$refs.form.resetValidation();
      this.cargarConfiguracion(this.Item.id_tipo);
    },
    cargarneumaticos(value = null, force = false) {
      this.MostrarConfiguracion = false;

      if (this.Item.id_configuracion != "" && !force) {
        this.cargarPosicionNeumatico(this.Item.id_configuracion).then((r) => {
          this.ItemsNeumaticos.forEach((element, i) => {
            // if (element != null) {
            this.ItemLlantas[i] = element;
            //     this.$set(this.ItemLlantas, element, true);
            // } else {
            //     this.ItemLlantas[i + 1] = false;
            //     this.$set(this.ItemLlantas, i + 1, false);
            // }
          });
        });
        this.$nextTick().then(() => {
          this.MostrarConfiguracion = true;
        });
      } else {
        this.ItemLlantas = {
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false,
          8: false,
          9: false,
          10: false,
          11: false,
          12: false,
          13: false,
          14: false,
          15: false,
          16: false,
          17: false,
          18: false,
          19: false,
          20: false,
          21: false,
          22: false,
        };
      }
    },
  },
  mounted() {
    //this.cargarneumaticos();
    if (this.Item.id != "") {
      this.cargarConfiguracion(this.Item.id_tipo);
      this.cargarPosicionNeumatico();
      this.cargarneumaticos();
      this.cargarModelos(this.Item.id_marca);
    } else {
      this.cargarConfiguracion(null);
    }
  },
};
</script>
<style scoped>
.letra-11 {
  font-size: 11pt;
}

.bg-actions {
  background-color: #f8fafc;
}

.schematic-card {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
}

.tire-btn {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  transition: transform 0.15s ease-in-out;
}

.tire-btn:hover {
  transform: scale(1.05);
}

.alert-chiquito {
  font-size: 12px;
  padding: 4px 8px;
  margin: 4px 0;
  background-color: rgba(244, 67, 54, 0.1) !important;
  color: #000 !important;
}

.alert-chiquito.v-alert__wrapper.v-icon {
  color: red !important;
}

.app-remanente-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #0284c7;
  font-size: 0.75rem;
}
</style>
